import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  atlassianLogoLabel: {
    id: 'SiteSelectorModal.atlassianLogoLabel',
    defaultMessage: 'Atlassian logo'
  },
  cancel: {
    id: 'SiteSelectorModal.cancel',
    defaultMessage: 'Cancel'
  },
  createPage: {
    id: 'SiteSelectorModal.createPage',
    defaultMessage: 'Create page'
  },
  selectASite: {
    id: 'SiteSelectorModal.selectASite',
    defaultMessage: 'Select a site'
  },
  startASite: {
    id: 'SiteSelectorModal.startASite',
    defaultMessage: 'Start a new site'
  },
  switchAccount: {
    id: 'SiteSelectorModal.switchAccount',
    defaultMessage: 'Sign in with a different account'
  }
});
